import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'

const routes = [
  {
    name: 'Accueil',
    path: '/',
    component:  () => import("@/views/Home.vue"),
    meta: {
      showNav: true,
      parallax: true,
    }
  },
  {
    name: 'TV',
    path: '/tv',
    component:  () => import("@/views/TV.vue"),
    meta: {
      showNav: true,
      parallax: false,
    }
  },
  {
    name: 'Photos',
    path: '/photos',
    component:  () => import("@/views/Photos.vue"),
    meta: {
      showNav: true,
      parallax: true,
    }
  },
  {
    name: 'Nos projets',
    path: '/projects',
    component:  () => import("@/views/Projects.vue"),
    meta: {
      showNav: true,
      parallax: true,
    }
  },
  {
    name: 'Dossiers',
    path: '/folders',
    component:  () => import("@/views/Folders.vue"),
    meta: {
      showNav: true,
      parallax: false,
    }
  },
  {
    name: 'Admin',
    path: '/admin',
    component:  () => import("@/views/Admin.vue"),
    meta: {
      showNav: true,
      parallax: true,
    }
  },
  {
    name: 'Parametres',
    path: '/parameters',
    component:  () => import("@/views/Parameters.vue"),
    meta: {
      showNav: true,
      parallax: true,
    }
  },
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0 };
  }
})

router.afterEach((to, from) => {
	nextTick(() => {
		document.title = 'LeaTvProd - ' + to.name
	})
})

export default router
